<template>
  <div class="component-section">
    <div class="component-section-header">
      <button class="btn-menu" @click="toggleComponentSection()">
        <img src="@/assets/cv-editor-icons/tab-menu.svg" />
      </button>

      <div class="component-info">
        <h4>CV</h4>
      </div>
    </div>
    <div class="component-section-body">
      <slot name="body"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "editor-menu",
  components: {},
  props: {

  },
  data() {
    return {
      isComponentMinimized: false,
    };
  },
  computed: {},
  watch: {},
  mounted() { },
  methods: {
    toggleComponentSection() {
      let vm = this;
      vm.isComponentMinimized = !vm.isComponentMinimized;
      vm.$emit("input", vm.isComponentMinimized);
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";

.component-section {
  width: 250px;
  transition: 500ms ease-in-out;
  height: 100%;
  background: #fff;
  border: 1px solid #eaeaea;
  border-radius: 5px;



  .component-section-header {
    height: 40px;
    display: flex;
    align-items: center;
    padding-left: 5px;
    padding-right: 5px;

    &.node {
      margin-top: 15px;
    }

    .btn-menu {
      background: transparent;
      border: none;

      img {
        width: 18px;
      }
    }

    .component-info {
      display: flex;
      align-items: center;
      transform: rotate(0deg);
      position: relative;
      top: 0px;
      transition: 500ms ease-in-out;

      h4 {
        color: #707070;
      }
    }
  }

  .component-section-body {
    background: #ffff;
    height: calc(100% - 40px);
    padding: 0px 5px;
    opacity: 1;
    transition: opacity 3000ms ease-in-out;
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  &.minimized {
    width: 50px;
    transition: 500ms ease-in-out;

    .component-section-header {
      height: unset;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      padding-left: 10px;
      padding-right: 15px;
      padding-top: 20px;
      background: #fff;
      height: 100%;

      .btn-menu {
        background: transparent;
        border: none;
      }

      .component-info {
        display: flex;
        align-items: center;
        transform: rotate(-90deg);
        position: relative;
        top: 27px;
        transition: 500ms ease-in-out;

        .icon {
          width: 22px;
          margin-right: 5px;
        }
      }
    }

    .component-section-body {
      background: #fff;
      opacity: 0;
      transition: 10ms ease-in-out;
      height: 500px;
    }
  }
}
</style>